export default {
  p: { x: 250, y: 155, b: 'ew', d: 100 },
  r: 50,
  s: [
    { x: 464, y: 350, b: 'ew', d: 100 },
    { x: 164, y: 150, b: 'ew', d: 100 },
    { x: 400, y: 380 },
    { x: 600, y: 480 },
  ],
  b: [{ x: 250, y: 155, b: 'ew', d: 100 }],
  g: [{ x: 700, y: 700 }],
  h: [
    { x: 260, y: 50 },
    { x: 580, y: 100 },
  ],
};
